// Get approval requests
export const GET_APPROVAL_REQUESTS = "GET_APPROVAL_REQUESTS";
export const GET_APPROVAL_REQUESTS_SUCCESS = "GET_APPROVAL_REQUESTS_SUCCESS";
export const GET_APPROVAL_REQUESTS_FAIL = "GET_APPROVAL_REQUESTS_FAIL";

// Cancel approval request
export const CANCEL_APPROVAL_REQUEST = "CANCEL_APPROVAL_REQUEST";
export const CANCEL_APPROVAL_REQUEST_SUCCESS = "CANCEL_APPROVAL_REQUEST_SUCCESS";
export const CANCEL_APPROVAL_REQUEST_FAIL = "CANCEL_APPROVAL_REQUEST_FAIL";

// Decide approval request (approve/reject)
export const DECIDE_APPROVAL_REQUEST = "DECIDE_APPROVAL_REQUEST";
export const DECIDE_APPROVAL_REQUEST_SUCCESS = "DECIDE_APPROVAL_REQUEST_SUCCESS";
export const DECIDE_APPROVAL_REQUEST_FAIL = "DECIDE_APPROVAL_REQUEST_FAIL";

// Dialog types
export const OPEN_CANCEL_REQUEST_DIALOG = "OPEN_CANCEL_REQUEST_DIALOG";
export const CLOSE_CANCEL_REQUEST_DIALOG = "CLOSE_CANCEL_REQUEST_DIALOG";
export const OPEN_DECIDE_REQUEST_DIALOG = "OPEN_DECIDE_REQUEST_DIALOG";
export const CLOSE_DECIDE_REQUEST_DIALOG = "CLOSE_DECIDE_REQUEST_DIALOG";

// Loading states
export const SET_LOADING = "SET_LOADING";
